import { useCallback, useState } from 'react';
import { toggleLinking } from '../state/actions/toggle-linking';
import { saveLinkingEnabled } from '../state/linking-persistance';
import { useLinkingEnabled, useWriteContext } from '../utils/use-context';
import { Button, ToolButton, Tooltip } from '@crabs-ai/ds-react';
import { useTranslations } from 'next-intl';
import { ViewTimeline, ViewTimelineFill } from '@crabs-ai/web-icons';
import { LinkingGuideDialog } from './linking-guide-dialog';
import { useProjectTypeContext } from '../contexts/project-type-context';

export function LinkingToggle() {
  const t = useTranslations();
  const writeContext = useWriteContext();
  const isLinkingEnabled = useLinkingEnabled();
  const { projectType } = useProjectTypeContext();
  const [isGuideOpen, setIsGuideOpen] = useState(false);

  const handleToggle = useCallback(() => {
    writeContext.setState({
      update: (state) => {
        const newState = toggleLinking(state);
        saveLinkingEnabled(newState.isLinkingEnabled, projectType);
        return newState;
      },
      commitToUndoStack: false,
    });
  }, [projectType, writeContext]);

  return (
    <>
      <Tooltip
        type="withButton"
        side="top"
        className="items-center"
        textNode={
          isLinkingEnabled
            ? t('Editor.timeline-controls.linking-off')
            : t('Editor.timeline-controls.linking-on')
        }
        buttonNode={
          <Button
            size="xsmall"
            hierarchy="tertiary"
            onClick={() => setIsGuideOpen(true)}
          >
            {t('Editor.timeline-controls.linking-what')}
          </Button>
        }
      >
        <ToolButton
          size="sm"
          isTransparent={false}
          state={isLinkingEnabled ? 'selected' : 'default'}
          onClick={handleToggle}
          aria-label={
            isLinkingEnabled ? 'Disable Track Link' : 'Enable Track Link'
          }
          aria-pressed={isLinkingEnabled}
          aria-keyshortcuts="KeyL"
        >
          {isLinkingEnabled ? (
            <ViewTimelineFill className="size-5" />
          ) : (
            <ViewTimeline className="size-5" />
          )}
        </ToolButton>
      </Tooltip>

      <LinkingGuideDialog
        open={isGuideOpen}
        onOpenChange={setIsGuideOpen}
      />
    </>
  );
}
